<div class="p1"
     *iCms="'copy' of content; content: 'html'"></div>